import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Dialog } from '@/shared/ui/Dialog';
import { useTabsStore } from '../tabs/tabsStore';
import { tabLabel } from '../tabs/model/types';
import { groupPalette } from '../tabs/lib/tabGroupColors';
import { NavIcon } from '../navMenu/NavIcon';
import { EmptyState } from '@/shared/ui/EmptyState';

export function MobileTabsSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
}) {
  const { t } = useTranslation();
  const tabs = useTabsStore((s) => s.tabs);
  const groups = useTabsStore((s) => s.groups);
  const { activate, close } = useTabsStore.getState();
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={t('shell.tabs')} size="sm">
      {tabs.length === 0 ? <EmptyState title={t('shell.noTabs')} /> : null}
      <ul className="divide-border divide-y">
        {tabs.map((tab) => {
          const group = tab.groupId ? groups.find((g) => g.groupId === tab.groupId) : undefined;
          return (
            <li key={tab.tabId} className="flex items-center gap-2 py-2">
              <button
                type="button"
                className="flex min-w-0 flex-1 items-center gap-2 text-left text-sm"
                onClick={() => {
                  activate(tab.tabId);
                  navigate(`/s/${tab.screenId ?? tab.uniqueKey}?tab=${tab.tabId}`, { replace: true });
                  onOpenChange(false);
                }}
              >
                {/* Grup rengi mobilde de görünür: masaüstünde gruplanan sekmeler telefonda
                  düz listeye düşüyor ve hangi işe ait oldukları kayboluyordu. */}
                {group ? (
                  <span
                    className="h-2.5 w-2.5 shrink-0 rounded-full"
                    style={{ backgroundColor: groupPalette(group.color).bg }}
                  />
                ) : null}
                <NavIcon
                  node={{
                    iconId: tab.iconId ?? null,
                    screenTypeName: tab.screenTypeName ?? null,
                    children: [],
                  }}
                />
                <span className="truncate">{tabLabel(tab)}</span>
              </button>
              <button
                type="button"
                aria-label={t('shell.tab.close')}
                onClick={() => close(tab.tabId)}
                className="text-fg-subtle hover:bg-bg-hover rounded p-1"
              >
                <X className="h-4 w-4" />
              </button>
            </li>
          );
        })}
      </ul>
    </Dialog>
  );
}
